import React, { Component } from 'react';
import { InputNumber } from './input-number';

export class InputNumberDouble extends Component {
  constructor(props) {
    super(props);
    const { value, feild1, feild2 } = props;
    this.state = {
      value: value ? value : {
        [feild1]: 0,
        [feild2]: 0,
      }
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (this.props.value !== newProps.value) {
      this.setState({ value: newProps.value })
    }
  }

  onChangeInput = (feild, data) => {
    const { value } = this.state;
    
    this.setState({
      value: {
        ...value,
        [feild]: data
      }
    }, () => {
      const { name } = this.props;
      this.props.onChange(this.state.value)
    })
  };

  render() {
    const { value } = this.state;
    const { feild1, feild2, disabled, disableSub, isOwner, typeOption } = this.props;
    return (
      <div style={{ display: 'flex', width: '100%' }}>
        <InputNumber
          is_money
          className={(!isOwner && typeOption !== 'create_new') ? 'hidePrice' : ''}
          disabled={disabled || (typeOption !== 'create_new' && !isOwner)}
          value={value[feild1]}
          onChange={data => this.onChangeInput(feild1, data)}
          suffix={'VNĐ/ngày'} />
        <InputNumber
          disabled={disableSub || (typeOption !== 'create_new' && !isOwner)}
          value={value[feild2]}
          onChange={data => this.onChangeInput(feild2, data)}
          suffix="Km" style={{ width: '50%', marginLeft: 5 }} />
      </div>
    )
  }
}
